<div class="quotation-workflow-container">
  <div class="workflow-header">
    <h2>
      {{ steps.indexOf(currentStep) + 1 }}/{{ steps.length }}:
      {{ currentStep | titlecase }}
    </h2>
    <p class="order-id">Order ID: {{ orderId }}</p>
  </div>

  <!-- Step Navigation -->
  <div class="workflow-steps">
    <div class="step-navigation">
      <div *ngFor="let step of steps; let i = index" class="step-wrapper">
        <div class="step-item" [ngClass]="{
          active: currentStep === step,
          completed: steps.indexOf(currentStep) > i
        }">
          <div class="step-icon-container">
            <img [src]="getStepImage(step)" alt="{{ step | titlecase }} Image" class="step-image" />
            <div class="step-number">{{ i + 1 }}</div>
          </div>
          <div class="step-content">
            <span class="step-title">{{ step | titlecase }}</span>
            <div class="step-indicator"></div>
          </div>
        </div>
        <div class="step-connector" *ngIf="i < steps.length - 1" [ngClass]="{
          completed: steps.indexOf(currentStep) > i + 1
        }"></div>
      </div>
    </div>
  </div>


  <!-- Quotation Form -->
  <div *ngIf="currentStep === 'quotation'" class="step-content">
    <form [formGroup]="forms['quotation']">
      <div class="p-grid p-fluid">
        <!-- Left Column -->
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="quotationNo" style="width: 120px; margin-right: 1rem;">Quotation No.</label>
            <div style="flex: 1;">
              <input id="quotationNo" type="text" pInputText formControlName="quotationNo" style="width: 50%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'quotationNo')">Quotation number is
                required</small>
            </div>
          </div>
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="customer" style="width: 120px; margin-right: 1rem;">Customer</label>
            <div class="customer-autocomplete" style="flex: 1;">
              <p-autoComplete id="customer" formControlName="customer" [suggestions]="filteredCustomers"
                (completeMethod)="filterCustomers($event)" field="label"
                [ngStyle]="{'background-color': 'white', 'height': '30px', 'width': '100%'}" [forceSelection]="false"
                (onSelect)="onCustomerSelect($event)" (onClear)="onCustomerClear()"
                placeholder="Type or select a customer" [showClear]="true">
              </p-autoComplete>
              <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'customer')">Customer is required</small>
            </div>
          </div>
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="email" style="width: 120px; margin-right: 1rem;">Email</label>
            <div style="flex: 1;">
              <input id="email" pInputText formControlName="email" style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'email')">Email is required</small>
            </div>
          </div>
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="customerAddress" style="width: 120px; margin-right: 1rem;">Address</label>
            <div style="flex: 1;">
              <input id="customerAddress" type="text" pInputText formControlName="customerAddress"
                style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'customerAddress')">Customer address is
                required</small>
            </div>
          </div>
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="country" style="width: 120px; margin-right: 1rem;">Country</label>
            <div style="flex: 1;">
              <input id="country" pInputText formControlName="country" style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'country')">Country is required</small>
            </div>
          </div>
          <div class="p-field" style="display: flex; align-items: flex-start; margin-bottom: 1rem; width: 100%;">
            <label for="description" style="width: 120px; margin-right: 1rem;">Reference<br>(Description)</label>
            <div style="flex: 1;">
              <textarea id="description" pInputTextarea formControlName="description" rows="5"
                style="width: 100%;"></textarea>
              <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'description')">Description is
                required</small>
            </div>
          </div>
        </div>

        <!-- Right Column -->
        <div class="p-col-12 p-md-6" style="display: flex; justify-content: flex-end;">
          <div style="width: 70%;padding-right: 50px;">
            <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem;">
              <label for="project" style="width: 30%; margin-right: 1rem;">Project</label>
              <div style="width: 70%;">
                <input id="project" type="text" pInputText formControlName="project" style="width: 100%;" />
                <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'project')">Project is required</small>
              </div>
            </div>
            <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem;">
              <label for="date" style="width: 30%; margin-right: 1rem;">Quotation Date</label>
              <div style="width: 70%;">
                <input id="date" type="date" pInputText formControlName="date" style="width: 100%;" />
                <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'date')">Date is required</small>
              </div>
            </div>
            <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem;">
              <label for="attention" style="width: 30%; margin-right: 1rem;">Attention</label>
              <div style="width: 70%;">
                <input id="attention" type="text" pInputText formControlName="attention" style="width: 100%;" />
                <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'attention')">Attention is
                  required</small>
              </div>
            </div>
            <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem;">
              <label for="totalPrice" style="width: 30%; margin-right: 1rem;">Total Price</label>
              <div style="width: 70%;">
                <input id="totalPrice" type="number" pInputText formControlName="totalPrice" style="width: 100%;" />
                <small class="p-error" *ngIf="isInvalidAndTouched('quotation', 'totalPrice')">Valid total price is
                  required</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Purchase Order Form -->
  <div *ngIf="currentStep === 'po'" class="step-content">
    <form [formGroup]="forms['po']">
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="quotationNoRef" style="width: 30%; margin-right: 1rem;">Quotation No.</label>
            <div style="flex: 1;">
              <input id="quotationNoRef" type="text" pInputText formControlName="quotationNo" readonly
                style="width: 60%;" />
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="poNumber" style="width: 30%; margin-right: 1rem;">PO Number</label>
            <div style="flex: 1;">
              <input id="poNumber" type="text" pInputText formControlName="poNumber" style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('po', 'poNumber')">PO number is required</small>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="customerNamePo" style="width: 30%; margin-right: 1rem;">Customer Name</label>
            <div style="flex: 1;">
              <input id="customerNamePo" type="text" pInputText formControlName="customerName" style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('po', 'customerName')">Customer name is required</small>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="date" style="width: 30%; margin-right: 1rem;">PO Date</label>
            <div style="flex: 1;">
              <input id="date" type="date" pInputText formControlName="date" style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('po', 'date')">Date is required</small>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="deliveryToCompany" style="width: 30%; margin-right: 1rem;">Address</label>
            <div style="flex: 1;">
              <input id="deliveryToCompany" type="text" pInputText formControlName="deliveryToCompany"
                style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('po', 'deliveryToCompany')">Delivery company is
                required</small>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="shipDate" style="width: 30%; margin-right: 1rem;">ETD Date</label>
            <div style="flex: 1;">
              <input id="shipDate" type="date" pInputText formControlName="shipDate" style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('po', 'shipDate')">Ship date is required</small>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="deliveryToAddress" style="width: 30%; margin-right: 1rem;">Delivery to<br>Address</label>
            <div style="flex: 1;">
              <input id="deliveryToAddress" type="text" pInputText formControlName="deliveryToAddress"
                style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('po', 'deliveryToAddress')">Delivery address is
                required</small>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="poTotalPrice" style="width: 30%; margin-right: 1rem;">Total Price</label>
            <div style="flex: 1;">
              <input id="poTotalPrice" type="number" pInputText formControlName="totalPrice" style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('po', 'totalPrice')">Valid total price is
                required</small>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-6">
          <div class="p-field" style="display: flex; align-items: center; margin-bottom: 1rem; width: 100%;">
            <label for="remarks" style="width: 30%; margin-right: 1rem;">Reference<br>Description</label>
            <div style="flex: 1;">
              <input id="remarks" type="text" pInputText formControlName="remarks" style="width: 100%;" />
              <small class="p-error" *ngIf="isInvalidAndTouched('po', 'remarks')">Reference is required</small>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- PI Form -->
  <div *ngIf="currentStep === 'pi'" class="step-content">
    <form [formGroup]="forms['pi']">
      <div class="p-grid p-fluid">
        <!-- Row 1: Quotation No., PO No., PI No. -->
        <div class="p-col-12">
          <div class="p-grid" style="padding-bottom: 15px;">
            <div class="p-col-4">
              <div class="horizontal-field">
                <label style="min-width: 95px;" for="piQuotationNo">Quotation No.</label>
                <div class="input-wrapper">
                  <input id="piQuotationNo" type="text" pInputText formControlName="quotationNo" readonly
                    class="horizontal-input" style="width: 130px;" />
                </div>
              </div>
            </div>
            <div class="p-col-4">
              <div class="horizontal-field">
                <label style="min-width: 95px;" for="piPoNumber">PO No.</label>
                <div class="input-wrapper">
                  <input id="piPoNumber" type="text" pInputText formControlName="poNumber" readonly
                    class="horizontal-input" style="width: 130px;" />
                </div>
              </div>
            </div>
            <div class="p-col-4">
              <div class="horizontal-field">
                <label style="min-width: 100px;" for="proformaInvoice">PI No.</label>
                <div class="input-wrapper">
                  <input id="proformaInvoice" type="text" pInputText formControlName="proformaInvoice"
                    class="horizontal-input" style="width: 165px;" />
                  <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'proformaInvoice')">Proforma invoice number is
                    required</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2: Customer Name and PI Date -->
        <div class="p-col-12" style="padding-bottom: 18px;">
          <div class="p-grid horizontal-row">
            <div class="p-col-6">
              <div class="horizontal-field">
                <label for="customerNamePi" class="horizontal-label">Customer Name</label>
                <input id="customerNamePi" type="text" pInputText formControlName="customerName"
                  class="horizontal-input" style="width: 438px;" />
                <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'customerName')">Required</small>
              </div>
            </div>
            <div class="p-col-6">
              <div class="horizontal-field" style="margin-right: 2vw;">
                <label for="piDate" class="horizontal-label">PI Date</label>
                <input id="piDate" type="date" pInputText formControlName="date" class="horizontal-input"
                  style="width: 165px" />
                <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'date')">Required</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 3: Address and ETD Date -->
        <div class="p-col-12" style="padding-bottom: 18px;">
          <div class="p-grid horizontal-row">
            <div class="p-col-6">
              <div class="horizontal-field">
                <label for="deliveryToCompanyPi" class="horizontal-label">Address</label>
                <input id="deliveryToCompanyPi" type="text" pInputText formControlName="deliveryToCompany"
                  class="horizontal-input" style="width: 438px;" />
                <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'deliveryToCompany')">Required</small>
              </div>
            </div>
            <div class="p-col-6">
              <div class="horizontal-field" style="margin-right: 2vw;">
                <label for="shipDatePi" class="horizontal-label">ETD Date</label>
                <input id="shipDatePi" type="date" pInputText formControlName="shipDate" class="horizontal-input"
                  style="width: 165px" />
                <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'shipDate')">Required</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 4: Description and Terms of Shipment -->
        <div class="p-col-12" style="padding-bottom: 18px;">
          <div class="p-grid horizontal-row">
            <div class="p-col-6">
              <div class="horizontal-field">
                <label for="piDescription" class="horizontal-label">Reference <br>(Description)</label>
                <textarea id="piDescription" pInputTextarea formControlName="description" rows="3"
                  class="horizontal-input" style="width: 438px;"></textarea>
                <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'description')">Required</small>
              </div>
            </div>
            <div class="p-col-6">
              <div class="horizontal-field" style="margin-right: 2vw;">
                <label for="termsOfShipment" class="horizontal-label">Terms of Shipment</label>
                <input id="termsOfShipment" type="text" pInputText formControlName="termsOfShipment"
                  class="horizontal-input" />
                <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'termsOfShipment')">Required</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 5: Delivery Address and Payment Terms -->
        <div class="p-col-12" style="padding-bottom: 18px;">
          <div class="p-grid horizontal-row">
            <div class="p-col-6">
              <div class="horizontal-field">
                <label for="deliveryToAddressPi" class="horizontal-label">Delivery to <br>(Address)</label>
                <input id="deliveryToAddressPi" type="text" pInputText formControlName="deliveryToAddress"
                  class="horizontal-input" style="width: 438px;" />
                <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'deliveryToAddress')">Required</small>
              </div>
            </div>
            <div class="p-col-6">
              <div class="horizontal-field" style="margin-right: 2vw;">
                <label for="paymentTerms" class="horizontal-label">Payment Terms</label>
                <input id="paymentTerms" type="text" pInputText formControlName="paymentTerms"
                  class="horizontal-input" />
                <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'paymentTerms')">Required</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 6: Total Price (right aligned) -->
        <div class="p-col-12" style="padding-bottom: 18px;">
          <div class="p-grid horizontal-row">
            <div class="p-col-6"></div>
            <div class="p-col-6">
              <div class="horizontal-field" style="margin-right: 2vw;">
                <label for="piTotalPrice" class="horizontal-label">Total Price</label>
                <input id="piTotalPrice" type="number" pInputText formControlName="totalPrice"
                  class="horizontal-input" />
                <small class="p-error" *ngIf="isInvalidAndTouched('pi', 'totalPrice')">Required</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Work Order Form -->
  <div *ngIf="currentStep === 'workOrder'" class="step-content">
    <form [formGroup]="forms['workOrder']">
      <div class="p-grid p-fluid">
        <!-- Row 1 -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="woQuotationNo">Quotation No.</label>
            <input id="woQuotationNo" type="text" pInputText formControlName="quotationNo" readonly
              style="width: 130px;" />
          </div>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="woPoNumber">PO Number</label>
            <input id="woPoNumber" type="text" pInputText formControlName="poNumber" readonly style="width: 130px;" />
          </div>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="jobNumber">Job Number</label>
            <input id="jobNumber" type="text" pInputText formControlName="jobNumber" style="width: 170px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'jobNumber')">Job number is required</small>
        </div>

        <!-- Row 2 -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="proformaInvoice">PI No.</label>
            <input id="proformaInvoice" type="text" pInputText formControlName="proformaInvoice" readonly
              style="width: 130px;" />
          </div>
        </div>
        <div class="p-col-4">
          <!-- Empty center column for this row -->
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="officiallySubmittedDate">Job Date</label>
            <input id="officiallySubmittedDate" type="date" pInputText formControlName="officiallySubmittedDate"
              style="width: 170px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'officiallySubmittedDate')">job date is
            required</small>
        </div>

        <!-- Row 3 -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="customerNameWo">Customer Name</label>
            <input id="customerNameWo" type="text" pInputText formControlName="customerName" style="width: 432px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'customerName')">Customer name is
            required</small>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="shipDatePi">ETD Date</label>
            <input id="shipDatePi" type="date" pInputText formControlName="shipDate" readonly style="width: 170px;" />
          </div>
        </div>

        <!-- Row 4 -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="customerAddressWo">Address</label>
            <input id="customerAddressWo" type="text" pInputText formControlName="customerAddress"
              style="width: 432px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'customerAddress')">Customer address is
            required</small>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="poReceivedDate">PO Received<br> Date</label>
            <input id="poReceivedDate" type="date" pInputText formControlName="poReceivedDate" style="width: 170px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'poReceivedDate')">PO received date is
            required</small>
        </div>

        <!-- Row 5 -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="projectName">Project Name</label>
            <input id="projectName" type="text" pInputText formControlName="projectName" style="width: 432px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'projectName')">Project name is
            required</small>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="officialSubmitDate">Officially <br>Submitted Date</label>
            <input id="officialSubmitDate" type="date" pInputText formControlName="officialSubmitDate"
              style="width: 170px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'officialSubmitDate')">Officially submitted
            date is required</small>
        </div>

        <!-- Row 6 -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="deliveryTerms">Delivery Terms</label>
            <input id="deliveryTerms" type="text" pInputText formControlName="deliveryTerms" style="width: 130px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'deliveryTerms')">Delivery terms is
            required</small>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="reviseNumber">Revise Number</label>
            <input id="reviseNumber" type="text" pInputText formControlName="reviseNumber" style="width: 130px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'reviseNumber')">Revise number is
            required</small>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="woTotalPrice">Total Price</label>
            <input id="woTotalPrice" type="number" pInputText formControlName="totalPrice" style="width: 170px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('workOrder', 'totalPrice')">Valid total price is
            required</small>
        </div>
      </div>
    </form>
  </div>

  <!-- Commercial Invoice Form -->
  <div *ngIf="currentStep === 'ci'" class="step-content">
    <form [formGroup]="forms['ci']">
      <div class="p-grid p-fluid">
        <!-- 1st Row -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="ciQuotationNo">Quotation No.</label>
            <input id="ciQuotationNo" type="text" pInputText formControlName="quotationNo" readonly />
          </div>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="poNumber">Po No.</label>
            <input id="poNumber" type="text" pInputText formControlName="poNumber" readonly />
          </div>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="ciJobNumber">Job Number</label>
            <input id="ciJobNumber" type="text" pInputText formControlName="jobNumber" readonly />
          </div>
        </div>

        <!-- 2nd Row -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="proformaInvoice">PI No.</label>
            <input id="proformaInvoice" type="text" pInputText formControlName="proformaInvoice" readonly />
          </div>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="shipDatePi">ETD Date</label>
            <input id="shipDatePi" type="date" pInputText formControlName="shipDate" readonly />
          </div>
        </div>

        <!-- 3rd Row -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="customerNameCi">Customer Name</label>
            <input id="customerNameCi" type="text" pInputText formControlName="customerName" style="width:500px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('ci', 'customerName')">Customer name is required</small>
        </div>

        <!-- 4th Row -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="customerAddressCi">Address</label>
            <input id="customerAddressCi" type="text" pInputText formControlName="customerAddress"
              style="width:500px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('ci', 'customerAddress')">Customer address is
            required</small>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="ciTotalPrice">Total Price</label>
            <input id="ciTotalPrice" type="number" pInputText formControlName="totalPrice" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('ci', 'totalPrice')">Valid total price is required</small>
        </div>

        <!-- Multiple Invoices Section -->
        <div class="p-col-12">
          <h3>Invoices</h3>
          <div formArrayName="invoices">
            <div *ngFor="let invoice of getInvoicesControls(); let i = index" [formGroupName]="i" class="invoice-row"
              style="border: 1px solid #ddd; padding: 10px; margin-bottom: 10px;">
              <div class="p-grid">
                <div class="p-col-4">
                  <div class="p-field" style="display: flex; align-items: center;">
                    <label style="min-width: 95px;" for="invoiceNo_{{i}}">Invoice No.</label>
                    <input id="invoiceNo_{{i}}" type="text" pInputText formControlName="invoiceNo" />
                  </div>
                  <small class="p-error"
                    *ngIf="invoice.get('invoiceNo')?.invalid && invoice.get('invoiceNo')?.touched">Invoice number is
                    required</small>
                </div>
                <div class="p-col-4">
                  <div class="p-field" style="display: flex; align-items: center;">
                    <label style="min-width: 95px;" for="invoiceDate_{{i}}">Invoice Date</label>
                    <input id="invoiceDate_{{i}}" type="date" pInputText formControlName="date" />
                  </div>
                  <small class="p-error" *ngIf="invoice.get('date')?.invalid && invoice.get('date')?.touched">Date is
                    required</small>
                </div>
                <div class="p-col-3">
                  <div class="p-field" style="display: flex; align-items: center;">
                    <label style="min-width: 95px;" for="invoicePrice_{{i}}">Invoice Price</label>
                    <input id="invoicePrice_{{i}}" type="number" pInputText formControlName="invoicePrice" />
                  </div>
                  <small class="p-error"
                    *ngIf="invoice.get('invoicePrice')?.invalid && invoice.get('invoicePrice')?.touched">Valid invoice
                    price is required</small>
                </div>
                <div class="p-col-1">
                  <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-sm"
                    (click)="removeInvoice(i)" label="Remove" *ngIf="getInvoicesControls().length > 1"></button>
                </div>
              </div>
            </div>
          </div>
          <button pButton type="button" icon="pi pi-plus" class="p-button-success" (click)="addInvoice()"
            label="Add Invoice"></button>
        </div>
      </div>
    </form>
  </div>

  <!-- Payment Form -->
  <div *ngIf="currentStep === 'payment'" class="step-content">
    <form [formGroup]="forms['payment']">
      <div class="p-grid p-fluid">
        <!-- Existing 1st-4th Row code remains the same -->
        <!-- 1st Row -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="paymentQuotationNo">Quotation No.</label>
            <input id="paymentQuotationNo" type="text" pInputText formControlName="quotationNo" readonly />
          </div>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="paymentPoNumber">Po No.</label>
            <input id="paymentPoNumber" type="text" pInputText formControlName="poNumber" readonly />
          </div>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="paymentJobNumber">Job Number</label>
            <input id="paymentJobNumber" type="text" pInputText formControlName="jobNumber" readonly />
          </div>
        </div>

        <!-- 2nd Row -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="paymentProformaInvoice">PI No.</label>
            <input id="paymentProformaInvoice" type="text" pInputText formControlName="proformaInvoice" readonly />
          </div>
        </div>

        <!-- 3rd Row -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="paymentCustomerName">Customer Name</label>
            <input id="paymentCustomerName" type="text" pInputText formControlName="customerName"
              style="width:200px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('payment', 'customerName')">Customer name is
            required</small>
        </div>

        <!-- 4th Row -->
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="paymentCustomerAddress">Address</label>
            <input id="paymentCustomerAddress" type="text" pInputText formControlName="customerAddress" readonly
              style="width:500px;" />
          </div>
        </div>
        <div class="p-col-4">
          <div class="p-field" style="display: flex; align-items: center;">
            <label style="min-width: 95px;" for="paymentTotalPrice">Total Price</label>
            <input id="paymentTotalPrice" type="number" pInputText formControlName="totalPrice" style="width: 100px;" />
          </div>
          <small class="p-error" *ngIf="isInvalidAndTouched('payment', 'totalPrice')">Valid total price is
            required</small>
        </div>

        <!-- Multiple Payments Section -->
        <div class="p-col-12">
          <h3>Payments</h3>
          <div formArrayName="payments">
            <div *ngFor="let payment of getPaymentsControls(); let i = index" [formGroupName]="i" class="payment-row"
              style="border: 1px solid #ddd; padding: 10px; margin-bottom: 10px;">
              <div class="p-grid">
                <div class="p-col-3">
                  <div class="p-field" style="display: flex; align-items: center;">
                    <label style="min-width: 95px;" for="paymentInvoiceNo_{{i}}">Invoice No.</label>
                    <p-dropdown id="paymentInvoiceNo_{{i}}" formControlName="invoiceNo" [options]="invoiceOptions"
                      optionLabel="label" optionValue="value" placeholder="Select Invoice"
                      (onChange)="onInvoiceSelect($event, i)" style="width: 180px;">
                    </p-dropdown>
                  </div>
                  <small class="p-error"
                    *ngIf="payment.get('invoiceNo')?.invalid && payment.get('invoiceNo')?.touched">Invoice selection is
                    required</small>
                </div>
                <div class="p-col-2">
                  <div class="p-field" style="display: flex; align-items: center;">
                    <label style="min-width: 95px;" for="invoicePrice_{{i}}">Invoice Price</label>
                    <input id="invoicePrice_{{i}}" type="number" pInputText formControlName="invoicePrice"
                      [disabled]="true" style="width: 100px;" />
                  </div>
                </div>
                <!-- Update the payment price input to handle changes -->
                <div class="p-col-2">
                  <div class="p-field" style="display: flex; align-items: center;">
                    <label style="min-width: 95px;" for="paymentPrice_{{i}}">Payment Price</label>
                    <input id="paymentPrice_{{i}}" type="number" pInputText formControlName="paymentPrice"
                      style="width: 100px;" />
                  </div>
                  <small class="p-error"
                    *ngIf="payment.get('paymentPrice')?.invalid && payment.get('paymentPrice')?.touched">Valid payment
                    price is required</small>
                </div>

                <div class="p-col-2">
                  <div class="p-field" style="display: flex; align-items: center;">
                    <label style="min-width: 95px;" for="remainderPrice_{{i}}">Remainder Price</label>
                    <input id="remainderPrice_{{i}}" type="number" pInputText formControlName="remainderPrice"
                      [disabled]="true" style="width: 100px;" />
                  </div>
                </div>
                <div class="p-col-2">
                  <div class="p-field" style="display: flex; align-items: center;">
                    <label style="min-width: 95px;" for="paymentReceivedDate_{{i}}">Payment<br>Received Date</label>
                    <input id="paymentReceivedDate_{{i}}" type="date" pInputText formControlName="paymentReceivedDate"
                      style="width: 180px;" />
                  </div>
                  <small class="p-error"
                    *ngIf="payment.get('paymentReceivedDate')?.invalid && payment.get('paymentReceivedDate')?.touched">Date
                    is required</small>
                </div>
                <div class="p-col-2">
                  <div class="p-field" style="display: flex; align-items: center;">
                    <label style="min-width: 95px;" for="paymentReceived_{{i}}">Payment<br>Received</label>
                    <p-dropdown id="paymentReceived_{{i}}" formControlName="paymentReceived"
                      [options]="[{ label: 'Yes', value: true }, { label: 'No', value: false }]" optionLabel="label"
                      optionValue="value" style="width: 100px;"></p-dropdown>
                  </div>
                  <small class="p-error"
                    *ngIf="payment.get('paymentReceived')?.invalid && payment.get('paymentReceived')?.touched">Status is
                    required</small>
                </div>

                <!-- Notes Field -->
                <div class="p-col-12" style="margin-top: 10px;">
                  <div class="p-field">
                    <label for="notes_{{i}}" style="display: block; margin-bottom: 5px;">Notes</label>
                    <textarea id="notes_{{i}}" pInputTextarea formControlName="notes"
                      style="width: 45%; min-height: 60px;" placeholder="Add any notes for this payment..."></textarea>
                  </div>
                </div>

                <!-- Multiple Payment Slips Upload Section -->
                <div class="p-col-12 payment-slips-container">
                  <div class="p-field">
                    <label class="payment-slips-label">
                      <strong>Payment Slips</strong>
                      <small class="p-text-secondary">(Optional - You can upload multiple files)</small>
                    </label>

                    <!-- File Upload Input -->
                    <div class="file-upload-wrapper">
                      <label for="paymentSlips_{{i}}" class="custom-file-input">
                        <i class="pi pi-upload"></i>
                        Choose Files
                      </label>
                      <input id="paymentSlips_{{i}}" type="file" accept=".pdf,.jpg,.jpeg,.png" multiple
                        (change)="onMultiplePaymentSlipsSelect($event, i)" />
                      <small class="file-format-info">Supported formats: PDF, JPG, PNG (Max 10MB each)</small>
                    </div>

                    <!-- Display Uploaded Files -->
                    <div *ngIf="hasPaymentSlips(i)" class="uploaded-files-container">
                      <h5 class="uploaded-files-header">
                        Uploaded Files
                        <span class="files-count">{{getPaymentSlips(i).length}}</span>
                      </h5>
                      <div class="uploaded-files-grid">
                        <div *ngFor="let slip of getPaymentSlips(i); let slipIndex = index" class="file-item">

                          <!-- File Info -->
                          <div class="file-info">
                            <i [class]="'file-icon ' + getFileIcon(slip.type)"></i>
                            <span class="file-name">{{slip.name}}</span>
                          </div>

                          <!-- File Size -->
                          <small class="file-size">{{formatFileSize(slip.size)}}</small>

                          <!-- Action Buttons -->
                          <div class="file-actions">
                            <button pButton type="button" icon="pi pi-eye"
                              class="p-button-text p-button-sm p-button-secondary"
                              (click)="previewPaymentSlip(i, slipIndex)" title="Preview">
                            </button>
                            <button pButton type="button" icon="pi pi-download"
                              class="p-button-text p-button-sm p-button-info"
                              (click)="downloadPaymentSlip(i, slipIndex)" title="Download">
                            </button>
                            <button pButton type="button" icon="pi pi-times"
                              class="p-button-text p-button-sm p-button-danger"
                              (click)="removePaymentSlip(i, slipIndex)" title="Remove">
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>


                <div class="p-col-1" style="display: flex; justify-content: flex-end;">
                  <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-sm"
                    (click)="removePayment(i)" label="Remove" *ngIf="getPaymentsControls().length > 1"></button>
                </div>
              </div>
            </div>
          </div>
          <button pButton type="button" icon="pi pi-plus" class="p-button-success" (click)="addPayment()"
            label="Add Payment"></button>
        </div>
      </div>
    </form>
  </div>

  <!-- Payment Slip Preview Dialog -->
  <p-dialog header="Payment Slip Preview" [(visible)]="displayPaymentSlipPreview" [modal]="true"
    [style]="{ width: '80vw' }" [maximizable]="true" [draggable]="false">
    <div *ngIf="currentPaymentSlipUrl; else noPaymentSlipMessage" style="height: 600px; overflow: hidden;">
      <div *ngIf="currentPaymentSlipType === 'pdf'" style="width: 100%; height: 100%;">
        <embed [src]="currentPaymentSlipUrl" type="application/pdf"
          style="width: 100%; height: 100%; object-fit: contain;" />
      </div>
      <div *ngIf="currentPaymentSlipType === 'image'" style="text-align: center;">
        <img [src]="currentPaymentSlipUrl" style="max-width: 100%; max-height: 600px; object-fit: contain;" />
      </div>
    </div>
    <ng-template #noPaymentSlipMessage>
      <p-messages severity="warn" [style]="{ display: 'block' }">
        <ng-template pTemplate>
          No valid payment slip file is available for preview.
        </ng-template>
      </p-messages>
    </ng-template>
    <div class="workflow-actions">
      <p-footer>
        <button pButton type="button" icon="pi pi-times" label="Close" class="p-button-text"
          (click)="displayPaymentSlipPreview = false"></button>
      </p-footer>
    </div>
  </p-dialog>

  <!-- Form Actions - MOVED OUTSIDE ALL FORM SECTIONS -->
  <div class="workflow-actions">
    <button pButton type="button" label="Previous" icon="pi pi-arrow-left" class="p-button-primary" id="bellow-btn"
      [disabled]="steps.indexOf(currentStep) === 0" (click)="onPrevious()"></button>
    <button pButton type="button" label="Save" icon="pi pi-save" id="bellow-btn" class="p-button-success"
      (click)="onSave()"></button>
    <button pButton type="button" label="Close" icon="pi pi-times" class="p-button-secondary" id="bellow-btn"
      (click)="onClose()"></button>
    <button pButton type="button" label="Next" icon="pi pi-arrow-right" class="p-button-primary"
      style="border-radius: 8px;" [disabled]="forms[currentStep].invalid" (click)="onNext()"></button>
  </div>
</div>